import Layout from "../../pages/snail/springFestival/Layout";
import Index from "../../pages/snail/springFestival/index";
import AnniverSary from "../../pages/snail/springFestival/anniversary";
import Info from "../../pages/snail/springFestival/info";
import PC from "../../pages/snail/springFestival/pc";

const base = "springFestival";

const routes = [
  {
    path: `/${base}`,
    component: Layout,
    redirect: `/${base}/anniversary`, // 初始页跳转
    children: [
      {
        path: `index`,
        name: `${base}-index`,
        component: Index,
      },
      {
        path: `enter*`,
        name: `${base}-enter`,
        component: Index,
      },
      {
        path: `anniversary*`,
        name: `${base}-anniversary`,
        component: AnniverSary,
      },
      {
        path: `info*`,
        name: `${base}-info`,
        component: Info,
      },
      {
        path: `pc*`,
        name: `${base}-pc`,
        component: PC,
      },
    ],
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/snail/springFestival.js